import createStore from "@/utils/create-store";
import Model from "@/models/admin/about-settings";

export default createStore({ Model });
